import { render } from "./ManufacturersList.vue?vue&type=template&id=6c6bb45d&scoped=true&ts=true"
import script from "./ManufacturersList.vue?vue&type=script&lang=ts"
export * from "./ManufacturersList.vue?vue&type=script&lang=ts"

import "./ManufacturersList.vue?vue&type=style&index=0&id=6c6bb45d&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6bb45d"]])

export default __exports__